import { FeatureFlag } from '@/utils/featureFlags';

export type FeatureFlagDefinition = {
  key: FeatureFlag;
  label: string;
  description: string;
};

export const FEATURE_FLAG_DEFINITIONS: FeatureFlagDefinition[] = [
  {
    key: FeatureFlag.ShowNewEventsUi,
    label: 'ShowNewEventsUi',
    description: 'Future Events UI in Analytics and Clusters.',
  },
  {
    key: FeatureFlag.ShowSignalPostsContext,
    label: 'ShowSignalPostsContext',
    description: 'Signal posts message context.',
  },
  {
    key: FeatureFlag.MarkAlertAsMonitoring,
    label: 'MarkAlertAsMonitoring',
    description: "'Mark as Monitoring' action for Argus alerts.",
  },
  {
    key: FeatureFlag.SupplyChainMonitoring,
    label: 'SupplyChainMonitoring',
    description:
      'Prototype Supply Chain Monitoring Overview page (sidebar entry + /supplychain/monitoring route).',
  },
  {
    key: FeatureFlag.AnalystTools,
    label: 'AnalystTools',
    description:
      'Analyst Tools: Observations and Events (sidebar entry + /analyst/observations and /analyst/events).',
  },
  {
    key: FeatureFlag.DrpSnapshot,
    label: 'DrpSnapshot',
    description: 'Experimental DRP Snapshot page (sidebar entry + /drp-snapshots).',
  },
  {
    key: FeatureFlag.NewLandingPage,
    label: 'New landing page',
    description: 'Shows the new landing page. Off by default, so the previous dashboard stays.',
  },
  {
    key: FeatureFlag.KarlaAssist,
    label: 'KarlaAssist',
    description:
      'Karla Assist: AI ticket review and entity autofill (create/edit drawers + admin panel).',
  },
  {
    key: FeatureFlag.AnalyticsBotnetFilters,
    label: 'AnalyticsBotnetFilters',
    description:
      'Botnet logs filter mode in the Analytics query bar (credential / host / password fields).',
  },
];
